<script lang="ts" setup>
import type { PropType } from 'vue'
import type { CleanTruckFee } from '~/models/pierPass'
import { getTerminalLabel } from '~/constants'

const props = defineProps({
  title: { type: String, required: true },
  data: { type: Object as PropType<CleanTruckFee>, required: true },
})

function yesNo(value: boolean | null | undefined) {
  if (value === null || value === undefined) return ''
  return value ? 'Yes' : 'No'
}
</script>

<template>
  <div class="pt-2 mb-4">
    <h4 class="mb-1 font-medium">{{ props.title }}:</h4>
    <el-descriptions border class="flex-1" :column="1">
      <el-descriptions-item label="Terminals">
        {{ Array.from(props.data.terminals).map(getTerminalLabel).join(', ') }}
      </el-descriptions-item>

      <el-descriptions-item label="Fee Paid">
        {{ yesNo(props.data.fee_paid) }}
      </el-descriptions-item>

      <el-descriptions-item label="Has Hold">
        {{ yesNo(props.data.has_hold) }}
      </el-descriptions-item>

      <el-descriptions-item label="Claimed by Other Company">
        {{ yesNo(props.data.claimed_by_other_company) }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<style scoped>
:deep(.el-descriptions__label) {
  width: 210px;
}
</style>
